export default __webpack_public_path__ + "static/media/CP3.b8314c3c.png";